import { createSlice } from '@reduxjs/toolkit';

export const debitNoteV2Slices = createSlice({
	name: 'debitNoteV2',
	initialState: {},
	reducers: {
		getDebitNoteList_request: (state) => {
			state.getDebitNoteList_requesting = true;
			state.getDebitNoteList_isSuccessful = undefined;
		},
		getDebitNoteList_success: (state, action) => {
			state.getDebitNoteList_requesting = false;
			state.getDebitNoteList_isSuccessful = true;
			state.debitNoteListListHeaders = action?.payload?.headers;

			state.debitNoteListList =  action?.payload?.data;
		},
		getDebitNoteList_failure: (state) => {
			state.getDebitNoteList_requesting = false;
			state.getDebitNoteList_isSuccessful = false;
			state.debitNoteListList = [];
		},

        deleteDebitNote_request: (state) => {
			state.deleteDebitNote_requesting = true;
			state.deleteDebitNote_isSuccessful = undefined;
		},
		deleteDebitNote_success: (state, action) => {
			state.deleteDebitNote_requesting = false;
			state.deleteDebitNote_isSuccessful = true;
		},
		deleteDebitNote_failure: (state) => {
			state.deleteDebitNote_requesting = false;
			state.deleteDebitNote_isSuccessful = false;
		},
	},
});

export const { 
	getDebitNoteList_request,
    getDebitNoteList_success,
    getDebitNoteList_failure,
    deleteDebitNote_request,
    deleteDebitNote_success,
    deleteDebitNote_failure
} = debitNoteV2Slices.actions;

export default debitNoteV2Slices.reducer;